import Lookup from './lookup.js';

export default class IssuerNewIdentificationCard extends Lookup
{
    
}
